import {Component,Input,OnInit} from '@angular/core';
import {ListView,TypeComparaison} from "@domain/common/list-view";
import {PopulationUsageItemComponent} from "@components/admin/entreprise/populations/population-details/population-usage/population-usage-item/population-usage-item.component";
import {PopulationUsage} from "@domain/admin/entreprise/population/population-usage";
import {TranslateService} from "@ngx-translate/core";
import {TypeProfil} from "@domain/user/user";

/**
 * Composant d'affichage de la page Population Usage
 *
 * @author Lionel Gimenez
 * @date 20/05/2025
 */
@Component({
    host: {'data-test-id': 'population-usage'},
    selector: 'population-usage',
    templateUrl: './population-usage.component.html'
})
export class PopulationUsageComponent implements OnInit {
    /** ListView des usages */
    usageListView: ListView<PopulationUsage,PopulationUsageItemComponent>;

    /** Id de la population */
    @Input() idPopulation: number;

    /**
     * Constructeur
     */
    constructor(
        public translateService: TranslateService,
    ) {
    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        this.usageListView = new ListView<PopulationUsage,PopulationUsageItemComponent>({
            uri: `/controller/population/getUsagePopulation?idPopulation=${this.idPopulation}`,
            title: this.translateService.instant('admin.entreprise.populations.usage.libelle'),
            component: PopulationUsageItemComponent,
            defaultOrder: 'fonction',
            //Définition des filtres
            listeFilters: [{
                title: this.translateService.instant('admin.entreprise.populations.usage.fonction'),
                clef: 'fonction',
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                multiple: true,
                listeValues: [
                    {
                        code: '' + TypeProfil.ASSISTANT,
                        libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.ASSISTANT)
                    },{
                        code: '' + TypeProfil.COLLABORATEUR,
                        libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.COLLABORATEUR)
                    },{
                        code: '' + TypeProfil.COMPTABLE,
                        libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.COMPTABLE)
                    },{
                        code: '' + TypeProfil.FOURNISSEUR,
                        libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.FOURNISSEUR)
                    },{
                        code: '' + TypeProfil.RESPONSABLE,
                        libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.RESPONSABLE)
                    },{
                        code: '' + TypeProfil.SOUS_ADMINISTRATEUR,
                        libelle: TypeProfil.getLibelle(this.translateService,TypeProfil.SOUS_ADMINISTRATEUR)
                    }
                ]
            }],
            isFilter: true
        })
    }
}